import React, { memo, useState } from "react";
import { useEditor } from "../../hooks/useEditor";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { useMessage } from "../../hooks/useMessage";
import { CommandHistory } from "./command-history";

export const CommandHistoryContainer = memo(() => {
	const editor = useEditor();
	const googleAnalytics = useGoogleAnalytics();

	const [canUndo, setCanUndo] = useState(editor.commandManager.canUndo());
	const [canRedo, setCanRedo] = useState(editor.commandManager.canRedo());

	useMessage(
		() => {
			setCanUndo(editor.commandManager.canUndo());
			setCanRedo(editor.commandManager.canRedo());
		},
		{
			captureInteractiveMessages: true, // Change size is currently a interactive message
		},
	);

	const undoAction = () => {
		googleAnalytics.trackEventToGa({ trackingAction: "UndoClicked" });
		editor.commandManager.undo();
	};

	const redoAction = () => {
		googleAnalytics.trackEventToGa({ trackingAction: "RedoClicked" });
		editor.commandManager.redo();
	};

	return (
		<CommandHistory
			isUndoDisabled={!canUndo}
			onUndoClick={undoAction}
			isRedoDisabled={!canRedo}
			onRedoClick={redoAction}
		/>
	);
});
CommandHistoryContainer.displayName = "CommandHistoryContainer";
